import type { Context, Plugin } from '@segment/analytics-next'
import {
  getLocaleFromPathname,
  removeLocaleFromPathname,
  removeLocaleFromUrl,
} from '@susu/headless-commerce/utils/localeUtils'
import { getAffiliateDataFromCookie } from '../awin'
import {
  createGAdata,
  getOneTrustConsent,
  transformOneTrustConsent,
} from './utils'

export const integrationPlugin = (): Plugin => {
  const withConsentContext = (ctx: Context): Context => {
    const url = new URL(window.location.href)

    ctx.updateEvent('context', {
      ...ctx.event.context,
      consent: transformOneTrustConsent(getOneTrustConsent()),
      locale: getLocaleFromPathname(url.pathname),
      ip: '0.0.0.0',
      page: {
        ...ctx.event.context?.page,
        path: removeLocaleFromPathname(url.pathname) + url.search,
        search: url.search,
        url: removeLocaleFromUrl(url),
      },
    })

    ctx.updateEvent('properties', {
      ...ctx.event.properties,
      ...getAffiliateDataFromCookie(document.cookie),
    })

    return ctx
  }

  return {
    name: 'Suitsupply GA Integration Plugin',
    type: 'enrichment',
    version: '1',
    isLoaded: () => true,
    identify: withConsentContext,
    load: createGAdata,
    page: withConsentContext,
    track: withConsentContext,
  }
}
